<footer *ngIf="appInfo$ | async as appInfo" data-cy="footer">
  <span class="px-2" data-cy="footer-version">Version {{appInfo.versionNumber}}</span>
  | <span class="px-2" data-cy="footer-build-date">Built {{appInfo.buildDate}}</span>
  <ng-container *ngIf="!isUatOrProd">
    | <span class="px-2" data-cy="footer-build-version">Build {{appInfo.buildVersion}}</span>
    | <span class="px-2" data-cy="footer-env-name">{{appInfo.environment}}</span>
    | <a mat-button routerLink="/demo">Dev UI demo</a>
  </ng-container>
</footer>